import React from "react";
import { ClipboardCheck, MapPin, Sparkles, Smile } from "lucide-react";

const steps = [
  {
    n: "01",
    title: "Book Online",
    desc: "Choose the package that suits your vehicle and pick a time.",
    Icon: ClipboardCheck,
  },
  {
    n: "02",
    title: "We Come To You",
    desc: "Home, workplace or any preferred location — our setup is fully mobile.",
    Icon: MapPin,
  },
  {
    n: "03",
    title: "Professional Detail",
    desc: "Every service performed with precision, premium products and care.",
    Icon: Sparkles,
  },
  {
    n: "04",
    title: "Drive Away Happy",
    desc: "Enjoy a spotless, protected vehicle with showroom-quality results.",
    Icon: Smile,
  },
];

export default function Process() {
  return (
    <section
      data-testid="process-section"
      className="section relative bg-[color:var(--bg)]"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center gap-3 mb-6 reveal">
          <span className="diamond-divider" />
          <span className="overline">How It Works</span>
        </div>
        <h2 className="reveal font-display tracking-tight text-neutral-900 text-4xl md:text-5xl lg:text-6xl max-w-3xl">
          A frictionless detailing
          <br />
          <span className="text-neutral-500 font-light italic">
            experience, end to end.
          </span>
        </h2>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-neutral-200">
          {steps.map((s) => (
            <div
              key={s.n}
              data-testid={`process-step-${s.n}`}
              className="bg-[color:var(--bg)] p-8 md:p-10 relative group hover:bg-white transition-colors reveal"
            >
              <div className="kbd-num group-hover:text-[color:var(--accent)]/30 transition-colors">
                {s.n}
              </div>
              <s.Icon
                className="text-[color:var(--accent)] mt-4"
                size={22}
                strokeWidth={1.5}
              />
              <h3 className="font-display text-neutral-900 text-xl mt-4 font-semibold">
                {s.title}
              </h3>
              <p className="text-neutral-500 text-sm leading-relaxed mt-3">
                {s.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
